import { useRedirect } from "react-admin";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { slotNameMap } from "@/constants";
import { formatListDate } from "@/utils/date-format";
import type { RazaEventsCalendarHallOverlay } from "./types";

function LabelValue({ label, value }: { label: string; value: string }) {
  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontWeight="bold">{label}</Typography>
      <Typography>{value || "—"}</Typography>
    </Grid>
  );
}

type Props = {
  open: boolean;
  onClose: () => void;
  overlay: RazaEventsCalendarHallOverlay | null;
};

export function RazaEventsHallOverlayDialog({ open, onClose, overlay }: Props) {
  const redirect = useRedirect();
  const slot =
    overlay?.slot && slotNameMap[overlay.slot] ? slotNameMap[overlay.slot] : (overlay?.slot ?? "");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }} py={1}>
        <Typography variant="h6" alignSelf="center">
          Hall booking
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ color: "text.secondary" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {overlay && (
          <Box>
            <Grid container spacing={2}>
              <LabelValue label="Hall" value={overlay.hallName ?? ""} />
              <LabelValue
                label="Date"
                value={overlay.date ? formatListDate(overlay.date, { utc: true }) : ""}
              />
              <LabelValue label="Slot" value={slot} />
              <LabelValue label="Purpose" value={overlay.purpose ?? ""} />
              <LabelValue label="Organiser" value={overlay.organiser ?? ""} />
              <LabelValue label="ITS No." value={overlay.itsNo ?? ""} />
              {overlay.isBlockedDate ? (
                <Grid size={{ xs: 12 }}>
                  <Typography color="warning.main">Blocked date</Typography>
                </Grid>
              ) : null}
            </Grid>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {overlay?.bookingId ? (
          <Button
            variant="contained"
            onClick={() => {
              onClose();
              redirect("show", "bookings", overlay.bookingId);
            }}
          >
            Open booking
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
